import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import { getStoreBuilder } from 'vuex-typex'
import { RootState } from './types'
import '@/properties/store'
import * as profile from '@/account/store'

var store: Store<RootState>

export function instance() {
  if (store) return store

  Vue.use(Vuex)
  const builder = getStoreBuilder<RootState>()
  store = builder.vuexStore({
    plugins: [plugin],
  })
}

function plugin(store: Store<RootState>) {
  profile.reactions()
}
